<template>
  <div>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel
        v-for="(faqTheme, indexTheme) in themesModifiable"
        :key="faqTheme.ordre"
      >
        <v-expansion-panel-header class="pl-4">
          <v-row>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-icon
                color="primary darken-1"
                :disabled="disabledOnUp(faqTheme)"
                @click.stop="onUp(indexTheme)"
              >
                mdi-arrow-up-bold
              </v-icon>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-icon
                color="primary darken-1"
                :disabled="disabledOnDown(faqTheme)"
                @click.stop="onDown(indexTheme)"
              >
                mdi-arrow-down-bold
              </v-icon>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-numeric-{{ faqTheme.ordre }}-circle
                  </v-icon>
                </template>
                <span>Ordre de tri du thème</span>
              </v-tooltip>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <div class="text-md-left ml-2">
                <v-card-text class="text-h5 font-weight-bold">
                  {{ faqTheme.libelle }}
                </v-card-text>
              </div>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="mr-2"
                    color="secondary"
                    v-on="on"
                    @click.stop="updateTheme(faqTheme)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                Modifier
              </v-tooltip>
            </v-col>
            <v-col
              align-self="center"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="red"
                    v-on="on"
                    @click.stop="deleteTheme(faqTheme)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                Supprimer
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider />
        <FaqQuestionsReponses
          :theme="faqTheme"
          @addQuestionReponse="addQuestionReponse"
          @updateQuestionReponse="updateQuestionReponse"
          @deleteQuestionReponse="deleteQuestionReponse"
          @saveQuestionReponseOrdre="saveQuestionReponseOrdre"
        />
      </v-expansion-panel>
      <v-row class="mt-2 ml-2">
        <v-col
          cols="12"
          md="2"
          sm="12"
          align-self="center"
        >
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-icon
                class="mr-2 add-theme"
                color="secondary"
                v-on="on"
                @click.stop="dialogSaisieTheme=true"
              >
                mdi-plus-circle-outline
              </v-icon>
            </template>
            Créer un thème
          </v-tooltip>
        </v-col>
      </v-row>
    </v-expansion-panels>
    <v-dialog
      v-model="dialogSaisieTheme"
      width="500"
      persistent
    >
      <FaqThemeSaisie
        :theme="themeModifie"
        @cancel="dialogSaisieTheme=false"
        @saveTheme="saveTheme"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogSaisieQuestionReponse"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
    >
      <FaqQuestionReponseSaisie
        :question-reponse="questionReponseModifie"
        @cancel="dialogSaisieQuestionReponse=false"
        @saveQuestionReponse="saveQuestionReponse"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogSupprimer"
      width="500"
      persistent
    >
      <ConfirmModal
        v-if="dialogSupprimerTheme"
        title="Suppression"
        cancel-text="Fermer"
        confirm-text="Tout supprimer"
        @cancel="dialogSupprimerTheme=false"
        @confirm="supprimerTheme"
      >
        <span>Etes-vous sûr de vouloir supprimer ce thème ainsi que toutes les questions/réponses de ce thème ?</span>
      </ConfirmModal>
      <ConfirmModal
        v-else
        title="Suppression"
        cancel-text="Fermer"
        confirm-text="Supprimer"
        @cancel="dialogSupprimerQuestionReponse=false"
        @confirm="supprimerQuestionReponse"
      >
        <span>Etes-vous sûr de vouloir supprimer cette question/réponse ?</span>
      </ConfirmModal>
    </v-dialog>
  </div>
</template>

<script>
import FaqQuestionsReponses from './faq-question-reponse.vue'
import FaqThemeSaisie from './faq-theme-saisie.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import FaqQuestionReponseSaisie from './faq-question-reponse-saisie.vue'

import {clone} from '@/utils/clone'

export default {
  name: 'FaqThemes',
  components: { FaqQuestionsReponses, FaqThemeSaisie, ConfirmModal, FaqQuestionReponseSaisie },
  props: {
    faqThemes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      panel: [],
      dialogSaisieTheme: false,
      dialogSupprimerTheme: false,
      dialogSaisieQuestionReponse: false,
      dialogSupprimerQuestionReponse: false,
      themeModifie: {},
      themeASupprimer: {},
      themeModifiable: {},
      themesModifiable: [],
      questionReponseModifie: {},
      questionReponseASupprimer: {}
    }
  },

  computed: {
    dialogSupprimer () {
      return this.dialogSupprimerTheme || this.dialogSupprimerQuestionReponse
    }
  },

  watch: {
    faqThemes: {
      handler () {
        this.themesModifiable = clone(this.faqThemes)
      },
      immediate: true
    }
  },

  methods: {
    updateTheme (theme) {
      this.dialogSaisieTheme = true
      this.themeModifie = clone(theme)
    },
    saveTheme (themeModifie) {
      this.$emit('saveTheme', themeModifie)
      this.themeModifie = {}
      this.dialogSaisieTheme = false
    },
    deleteTheme (theme) {
      this.dialogSupprimerTheme = true
      this.themeASupprimer = clone(theme)
    },
    supprimerTheme () {
      this.$emit('deleteTheme', this.themeASupprimer)
      this.dialogSupprimerTheme = false
    },
    addQuestionReponse (isDialogSaisieQuestionReponse, questionReponse) {
      this.dialogSaisieQuestionReponse = isDialogSaisieQuestionReponse
      this.questionReponseModifie.idTheme = questionReponse.idTheme
    },
    updateQuestionReponse (isDialogSaisieQuestionReponse, questionReponseModifie) {
      this.dialogSaisieQuestionReponse = isDialogSaisieQuestionReponse
      this.questionReponseModifie = clone(questionReponseModifie)
    },
    saveQuestionReponse (questionReponseModifie) {
      this.$emit('saveFaqQuestionReponse', questionReponseModifie)
      this.questionReponseModifie = {}
      this.dialogSaisieQuestionReponse = false
    },
    saveQuestionReponseOrdre (questionReponseModifie) {
      this.$emit('saveFaqQuestionReponse', questionReponseModifie)
    },
    deleteQuestionReponse (isDialogSuppressionQuestionReponse, questionReponseASupprimer) {
      this.dialogSupprimerQuestionReponse = isDialogSuppressionQuestionReponse
      this.questionReponseASupprimer = clone(questionReponseASupprimer)
    },
    supprimerQuestionReponse () {
      this.$emit('deleteFaqQuestionReponse', this.questionReponseASupprimer)
      this.dialogSupprimerQuestionReponse = false
    },
    disabledOnUp (theme) {
      return (theme.ordre === 1 || this.themesModifiable.length === 1)
    },
    disabledOnDown (theme) {
      return (theme.ordre === this.themesModifiable.length || this.themesModifiable.length === 1)
    },
    onUp (index) {
      if (index > 0) {
        this.themesModifiable[index].ordre--
        this.$emit('saveTheme', this.themesModifiable[index])
        this.themesModifiable[index - 1].ordre++
        this.$emit('saveTheme', this.themesModifiable[index - 1])
      }
    },
    onDown (index) {
      this.themesModifiable[index].ordre++
      this.$emit('saveTheme', this.themesModifiable[index])
      this.themesModifiable[index + 1].ordre--
      this.$emit('saveTheme', this.themesModifiable[index + 1])
    }
  }
}
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}
.add-theme {
  font-size: 50px;
}
</style>